import { useNavigate, useSearch } from "@tanstack/react-router";
import { ListModal } from "./ListModal";

export function ListModalRouter() {
    const search = useSearch({ from: "/_hub/$customerId/dashboard" });
    const navigate = useNavigate();

    const close = () => {
        void navigate({
            to: ".",
            search: (prev) => ({
                ...prev,
                list: undefined,
                editList: undefined,
                listFrom: undefined,
                listTemplate: undefined,
            }),
        });
    };

    if (search.list === undefined) {
        return null;
    }

    if (search.list === "new") {
        return (
            <ListModal
                mode="create"
                sourceId={search.listFrom}
                template={search.listTemplate === 1}
                onClose={close}
            />
        );
    }

    if (search.editList === 1) {
        return <ListModal mode="edit" listId={search.list} onClose={close} />;
    }

    return <ListModal mode="view" listId={search.list} onClose={close} />;
}
